 import { Base64 } from 'js-base64';
 import {groupMemberInfo,groupInfo} from  './errInfo'
 import {getGroupMember,getGroupInfo} from './ISdkAjax'
 import {localStorages} from '../storage/localStorage'
 import CONFERENCEMEET from '../languages/zh-cn'
export default class CClnterface{
    constructor() {
        this._groupList = [];
        this._joinerList = [];
        this._noJoinList = [];
        this._applyList = [];
        this._InviteList = [];
        this._leaveList = [];
        this._noStatusList = [];
    }
    /**获取群信息：包括获取群主和群用户列表**/
    async getUserInfos(uid){
      let groupInfos = null;
      let loginInfo = localStorages.get(`loginInfo_${uid}`);
      let group = groupInfo(await getGroupInfo({gid:loginInfo.gid,cid:loginInfo.gcid,sid:loginInfo.sid,uid:loginInfo.uid}).catch(err=>{return err}));
      let groupMember = groupMemberInfo(await getGroupMember({gid:loginInfo.gid,cid:loginInfo.gcid,sid:loginInfo.sid}).catch(err=>{return err}));
      if(group.code == 0){
        groupInfos = group.info
      };
      if(groupMember.code == 0){
        this._groupList = groupMember.info;
        this._groupList.forEach(group=>{group.cid = group.ucid})
      }
      if(group.code == 0 && groupMember.code == 0){
        return {
           groupList:this._groupList,
           groupInfos,
           hostId:this.getHostMember() && this.getHostMember().uid ? this.getHostMember().uid : null ,
           hostName:this.getHostMember() && this.getHostMember().name ? this.getHostMember().name : null ,
           isHost:this.getHostMember() && this.getHostMember().uid && this.getHostMember().uid == loginInfo.uid ? true : false,
           hostCid:this.getHostMember() && this.getHostMember().ucid ? this.getHostMember().ucid : null
        }
      }
    }
    /*更新groupList*/
    updateGrouoList(groupList,info){
        let group = groupList.find((group)=>{if(group.uid == info.uid && group.cid == info.cid){return group}});
        if(!group){groupList.push(info)}else {
            group['sort'] = info.sort != undefined  ? info.sort : group['sort'];
            group['note'] = info.note != undefined  ? info.note : group['note'];
            group['speak'] = info.speak != undefined  ? info.speak : group['speak'];
            group['share'] = info.share != undefined  ? info.share : group['share'];
            group['audio'] = info.audio != undefined  ? info.audio : group['audio'];
        };
    }
    /*同步参会人列表权限值
    *status:0初始化part
    *       1初始化selfpart
    * */
    syncParticipant(part,grouplist,status){
		if(!part)return
        if(!part.uid){
             part.uid = JSON.parse(Base64.decode(part.userId)).uid;
             part.cid = JSON.parse(Base64.decode(part.userId)).cid
        };
        var groupUser = null;
        if(status == 0){
            groupUser = grouplist.find((member=>{if(member.uid ==  part.uid){return member}}));
        }else {
            groupUser = grouplist
       };
        if(!groupUser) return;
        part['audio'] = groupUser.audio;
        part['sort'] = groupUser.sort?groupUser.sort:0;
        part['note'] = groupUser.note;
        part['share'] = groupUser.share;
    }
    /*获取Sort的最大值*/
    getSortMax(partList){
        // console.log(partList);
        console.log(partList.map(item => {
            return item.sort
        }));
        return Math.max.apply(Math,partList.map(item => { return item.sort}))
    }
    /*根据群成员属性更新参会人列表*/
    updataPartList(partList,member){
        partList.forEach(part=>{
            member.requestData.user.forEach(user=>{
                if(user.uid == part.uid){
                    part[member.requestData.set.type] = member.requestData.set.value;
                }
            })
        });
    }
    /*sortPartList:（1）存在主持人和我：主持人第一位，我第二位，其次时sort值排序，其次时time时间排序
    * （2）不存在主持人时：我第一位，sort值排，time排*/
    sortPartList(partList,selfParticipant,hostId){
        this._getNormalPartList(partList,selfParticipant,hostId)
    }
    /*获取不等于自己和主持人的用户*/
    _getNormalPartList(partList,selfParticipant,hostId){
        this._getTimeSortPart(partList);   
        this._getSortPart(partList);  //置顶
        this._getPexipsort(partList); //pexip
        this._getTypeSortPart(partList); //连麦
    
    
        let hostJoinInfo = partList.find((participant,index)=>{if(participant.uid == hostId){return {participant,index}}});
        let selfPartInfo =  partList.find((participant,index)=>{if(participant.id == selfParticipant.id){return {participant,index}}});
// 		/*存在主持人：主持人第一位，自己第二位
// 		 * （1）存在主持人：排主持人第一位，不存在排自己第一位
// 		 * （2）参会人：存在主持人：自己在非主持人的情况下排第二位
// 		 */
      if(hostJoinInfo){
			hostJoinInfo.ishost = true;
			var hostIndex = partList.findIndex((part)=>{return part == hostJoinInfo});
 			var str = partList.splice(hostIndex, 1);
			partList.unshift(str[0]);
		}else{
		/*不存在主持人:自己排第一位*/
			var selfPartIndex = partList.findIndex((part)=>{return part == selfPartInfo});
			var str1 = partList.splice(selfPartIndex, 1);
		     partList.unshift(str1[0]);
		}
		if(hostJoinInfo && !selfPartInfo.ishost){
			var selfPartIndex = partList.findIndex((part)=>{return part == selfPartInfo});
			var str2 = partList.splice(selfPartIndex, 1);
			partList.splice(1,0,str2[0])
		}
		 // console.timeEnd('time1')
//         partList.forEach((participant,index)=>{
//             if(hostJoinInfo){
//                 if(participant.ishost){
//                     var str = partList.splice(index, 1);
//                     partList.unshift(str[0]);
//                 }
//             }else{
//                 if(selfParticipant && participant.id == selfParticipant.id){
//                     var str = partList.splice(index, 1);
//                      partList.unshift(str[0]);
//                 }
//             }
//         });
//         partList.forEach((participant,index)=>{if(hostJoinInfo.length != 0){{if(!participant.ishost && selfParticipant && participant.id == selfParticipant.id){var str = partList.splice(index, 1);partList.splice(1,0,str[0])}}}})
      // console.log(partList);
	}
     /*根据typesort排序*/
     _getTypeSortPart(joinerList){
        joinerList.sort(this._downSortcompare('typesort'));
    }
    // 根据pexip排序
    _getPexipsort(joinerList){
        joinerList.sort(this._downSortcompare('pexipsort'));
    }
    /*获取sort值大于0并且不等于自己和主持人的*/
    _getSortPart(joinerList){
        joinerList.sort(this._downSortcompare('sort'));
    }
    /*获取sort<=0并且不是自己和主持人的按时间排序*/
    _getTimeSortPart(joinerList){
        joinerList.sort(this._upSortcompare('timestamp'))
    }
    _downSortcompare(property) {
        return function (a, b) {
            var value1 = a[property];
            var value2 = b[property];
            return value2 - value1;
        }
    }
    _upSortcompare(property){
        return function (a, b) {
            var value1 = a[property];
            var value2 = b[property];
            return value1 - value2;
        }
    }
    /*获取群主*/
    getHostMember(){
      return this._groupList.find((grop)=>{if(grop.type == 3){return grop}})
    }
	/*获取申请消息列表*/
	isExitApply(groupList){
	  let grouper = groupList.find((grouper)=>{return grouper.status == 3})
		if(grouper){return true}else{return false};
	}
    /*获取未入会列表*/
    getNojoinList(partList,groupList){
		this._leaveList = [];
		this._applyList = [];
		this._noStatusList = [];
		this._InviteList = [];
        for(var i=0;i<groupList.length;i++){
            var groupuid = groupList[i].uid;
            var isExist = false;
            for (var j=0;j<partList.length;j++){
                var partuid = partList[j].uid;
                if(groupuid == partuid){
                    isExist = true;
                }
            };
            if(!isExist){
                if(groupList[i].status == 6 || groupList[i].status == 7 || groupList[i].status == 4 ||  groupList[i].status == 1){
                    this.modifyKeyword(groupList[i]);
                    groupList[i].cid = groupList[i].ucid;
                    this._leaveList.push(groupList[i]);
                }else if(groupList[i].status == 3){
                    this.modifyKeyword(groupList[i]);
                    groupList[i].cid = groupList[i].ucid;
                    this._applyList.push(groupList[i])
                }else if(groupList[i].status == 0){
                    this.modifyKeyword(groupList[i]);
                    groupList[i].cid = groupList[i].ucid;
                    this._noStatusList.push(groupList[i])
                }else if(groupList[i].status == 2 || groupList[i].status == 8){
                    this.modifyKeyword(groupList[i]);
                    groupList[i].cid = groupList[i].ucid;
                    this._InviteList.push(groupList[i])
                }
                this._noStatusList.sort(this._upSortcompare('updatetime'));
                this._InviteList.sort(this._downSortcompare('updatetime')); //status:2,8
                this._applyList.sort(this._upSortcompare('updatetime'));//status:3
                this._leaveList.sort(this._downSortcompare('updatetime'));//status:1,4,6,7
            }
        }
        this._noJoinList = [...this._applyList,...this._InviteList,...this._noStatusList,...this._leaveList];
        return this._noJoinList
    }
    /*在未入会列表中查找某人*/
    findNoJoinUser(nojoinlist,user){
        let noJoiner = nojoinlist.find((nojoiner)=>{if(nojoiner.uid == user.uid && nojoiner.cid == user.cid){return nojoiner}});
        if(noJoiner){
          let noJoinerIndex = nojoinlist.findIndex((nojoiner)=>{return nojoiner.uid == user.uid && nojoiner.cid == user.cid});
          return {noJoiner:noJoiner,noJoinerIndex:noJoinerIndex}
        }else{
           return false
        }
    }

    /*查找type='applying'和type='alreadyleave'的位置并在未入会列表中插入
    * 邀请的排在最后一个applying的下面，申请的排在最后一个appliying的下面，已离会的排在第一个alreadyleave的上面
    * type:排序的类型：0申请0r邀请，1已离会
    * nojoinlist：被排序列表
    * user：待插入数据,数组/对象。
    * */
    nojoinListSort(nojoinlist,user,type){
        var sortIndex = null;
        if(type == 0){
           let ApplyLength = nojoinlist.filter(nojoin=>{if(nojoin.type == 'applying'){ return nojoin}}).length;
            sortIndex = ApplyLength;
        }else{
           let LeaveLength = nojoinlist.filter(nojoin=>{if(nojoin.type == 'alreadyleave'){ return nojoin}}).length;
           sortIndex = nojoinlist.length-LeaveLength
        }
        if(user instanceof Array){
          nojoinlist.splice(sortIndex, 0, ...user)
        }else{
          nojoinlist.splice(sortIndex,0,user)
        };
    }
    /*修改未入会列表显示状态的关键字
	    已离开：1(同意邀请)4(同意申请)6(已离开)7(已被踢)
	    申请中：3(申请中)
	    邀请：2(拒绝邀请)8取消呼叫  100 占线 呼叫中101
	    无状态：0(邀请中)
	    不显示在未入会列表：5(拒绝申请)
    * */
    modifyKeyword(member){
        member.isSelect = false;
        switch (member.status){
            case 0:
                 member.type = '';
                 break;
            case 1:
                member.type = 'alreadyleave';
                break;
            case 2:
                 member.type = 'reject';
                 break;
            case 3:
                 member.type = 'applying';
                 break;
            case 4:
                 member.type = 'alreadyleave';
                 break;
            case 5:
                 member.type = 'refuseapply';
                 break;
            case 6:
                 member.type = 'alreadyleave';
                 break;
            case 7:
                  member.type = 'alreadyleave';
                  break;
           case 8:
                  member.type = 'cancelInvite';
                  break;
        }
    }
    /*更新未入会列表
    * status:0 删除
    *        1 修改
    * */
    updataNoJoinlist(status,nojoinList,groupInfo){
        switch (status){
            case 0:
                for(var i = 0;i<nojoinList.length;i++){
                    if(nojoinList[i].uid == groupInfo.uid){
                        nojoinList.splice(i,1);
                        break;
                    }
                }
                break;
            case 1:
                let noJoiner =  this.findNoJoinUser(nojoinList,groupInfo);
                if(noJoiner){
                  if(noJoiner.noJoiner.type == 'applying' && groupInfo.type == 'applying'){groupInfo.isSelect = false;return};
                  nojoinList.splice(noJoiner.noJoinerIndex,1);
                };
	         			groupInfo['isSelect'] = false;
                if(groupInfo.type == 'applying' || groupInfo.type == 'invite' || groupInfo.type == 'busyline'  || groupInfo.type == 'reject'){
                    this.nojoinListSort(nojoinList,groupInfo,0)
                }else if(groupInfo.type = 'alreadyleave'){
                    this.nojoinListSort(nojoinList,groupInfo,1)
                }
                break;
        };

    }
    /*改变参会人列表中主持人*/
    changePartListHost(partlist,hostId,selfPart){
		/*改变原主持人的主持人状态为false*/
		var oldHost = partlist.find((part)=>{if(part.ishost){return part}});
		if(oldHost){oldHost.ishost = false};
		/*将新主持人的状态改变为true*/
		var newHost = partlist.find((part)=>{if(part.uid == hostId){return part}});
	    if(newHost){  newHost.ishost = true;}
		/*排序*/
        this.sortPartList(partlist,selfPart,hostId);
        this.delApplyHandel(partlist);
    }
    /*申请消息：群主接收及改变参会人的申请状态*/
    handleApplyPower(partlist,applyInfo){
        let applyer = partlist.find((part)=>{if(part.uid == applyInfo.applicant.uid){return part}});
        if(applyInfo.type == 'audio'){
            applyer['applyAudio'] = true;
        }else if(applyInfo.type == 'share'){
            applyer['applyShare'] = true;
        }
    }
    /*转移主持人后：将申请消息删除*/
    delApplyHandel(partList){
        for(var i = 0;i<partList.length;i++){
             if(partList[i].applyShare && partList[i].applyShare == true){
                 partList[i].applyShare = false;
             }else if(partList[i].applyAudio && partList[i].applyAudio == true){
                 partList[i].applyAudio = false;
             }
        }
    }
    /**会控操作失败提示
     * status:0全局操作  1：个人操作
     * data:{type:'share/note/audio/sort',value:0/1}
     * **/
    meetFailedInfo(data,status){
        var ErrInfo = {
           code:1,
           info:null
        };
        switch (data.type){
          case 'audio':
             //全局操作提示
             if(status == 0){
               ErrInfo.info = data.type == 0 ? CONFERENCEMEET.MEET_MUTE_FAILED : CONFERENCEMEET.MEET_UNMUTE_FAILED;
             //个人时：主持人解除或开启个人时失败
             }else{
               ErrInfo.info = data.type == 0 ? CONFERENCEMEET.MUTE_CLOSE_FAILED : CONFERENCEMEET.MUTE_OPEN_FAILED
             }
             break;
          case 'share':
             if(status == 0){
              ErrInfo.info = data.type == 0 ? CONFERENCEMEET.FORBIT_PART_SHARE_FAILED : CONFERENCEMEET.PERMIT_PART_SAHRE_FAILED;
              //个人时：主持人解除或开启个人时失败
             }else{
              ErrInfo.info = data.type == 0 ? CONFERENCEMEET.FORBIT_SHARE_FAILED : CONFERENCEMEET.PERMIT_SHARE_FAILED
             }
             break;
          case 'note':
             ErrInfo.info = data.type == 0 ? CONFERENCEMEET.FORBIT_NOTE_FAILED : CONFERENCEMEET.PERMIT_NOTE_FAILED;
             break;
          case 'sort':
             break;
          case 'transferHost':
            ErrInfo.info = CONFERENCEMEET.TRANSFER_HOST_FAILED;
            break;
        };
        return ErrInfo
    }
    /**获取申请入会的人数**/
    getApplyJoin(inviteList){
        return inviteList.filter(invite=>{return invite.type == 'applying'})
    }
    /***获取申请讲话的人数**/
    getApplySpeakNumber(participantList){
      return participantList.filter(invite=>{return invite.applyAudio})
    }
    /**获取申请共享的人数**/
    getApplySpeakNumber(participantList){
      return participantList.filter(invite=>{return invite.applyShare})
    }
}
